export function formatDisplayPrice(value, isAnnual = false) {
  // Requirements: no decimals if whole number and put in comma notation for numbers >= 1000
  let number = value;
  if (number <= 0) return 'Free';
  if (isAnnual) number *= 12;

  if (number % 1 !== 0) {
    return `$${number.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
  }
  return `$${number.toLocaleString()}`;
}
